import { observer } from "mobx-react";
import React from "react";
import PatientSurvey from "components/UI/organisms/patient/detail/survey";

const PatientSurveyPage = () => <PatientSurvey />;

export default observer(PatientSurveyPage);
